import {BOOKINGHTTP, HTTP} from '../../common/http';

import {
  SET_ADVERTS,
} from './mutation-types';
import {CREATE_ERROR} from "../errors/mutation-types";

export function fetchAdverts({ commit }, sourceId) {
  HTTP.get(`/adverts?source_id=${sourceId}`)
    .then(({ data }) => commit(SET_ADVERTS, data));
};

export function fetchOrRefreshToken({ dispatch, state, commit  }) {
  const errors = [];

  BOOKINGHTTP.get(`user/token`).then(response => {
    if (response.data.errors) {
      commit('setUserToken', null);
      window.greenmotion.authenticated = false;


      dispatch('postFrameSearch')
        .then(({id, currency, guestToken}) => {
          if (id) {
            const path = '/quotes/' + id;
            const opts = [
              guestToken ? `gt=${guestToken}` : null,
              `c=${currency}`,
              `refreshed=true`
            ].filter((x) => x).join('&');
            top.location = `${path}?${opts}`;
          }
        });

      commit(CREATE_ERROR, response.data.errors);
    } else {
      commit('setUserToken', response.data.access_token);
      errors.push('please_refresh');
    }

    return errors;
  });
}
